import { forwardRef } from "react";
import { Circle, Group, Rect, Text } from "react-konva";
import Konva from "konva";

interface ShapreLoaderComponentProps {
  containerWidth: number;
  containerHeight: number;
}

const ShapreLoaderComponent = forwardRef<
  Konva.Group,
  ShapreLoaderComponentProps
>(({ containerWidth, containerHeight }, ref) => {
  return (
    <Group
      ref={ref}
      listening={false}
      x={containerWidth / 2}
      y={containerHeight / 2}
    >
      <Rect
        width={150}
        height={80}
        offsetX={75}
        offsetY={35}
        fill="#ffffff"
        stroke="#d0d0d0"
        cornerRadius={8}
        shadowColor="rgba(0,0,0,0.18)"
        shadowBlur={8}
        shadowOffsetY={4}
        shadowOpacity={0.4}
      />

      <Circle
        name="loader-circle"
        radius={18}
        stroke="#1976D2"
        strokeWidth={4}
        dash={[12, 8]}
        y={-5}
      />

      <Text
        text="Loading Assets..."
        fontSize={13}
        fill="#333"
        fontStyle="bold"
        y={22}
        align="center"
        offsetX={50}
      />
    </Group>
  );
});

ShapreLoaderComponent.displayName = "ShapreLoaderComponent";

export default ShapreLoaderComponent;
